<template>
    <nav class="c-m-menu-desktop" id="header-nav">
        <ul class="c-m-menu-desktop__list c-m-menu-desktop__list--level-0">
            <menu-item-desktop
                v-for="(value, key) in items"
                :key="key"
                :item="value"
                :level="0"
            ></menu-item-desktop>
        </ul>
        <!-- Hårdkodade länkar: -->
        <ul
            class="c-m-menu-desktop__list c-m-menu-desktop__list--level-0 c-m-menu-desktop__list--primary"
        >
            <li
                class="c-m-menu-desktop__item"
                @click="displayAtClick('showContactInfo')"
                @mouseenter="showContactInfo = true"
                @mouseleave="showContactInfo = false"
            >
                <router-link
                    class="c-m-menu-desktop__link c-m-menu-desktop__link--flipped"
                    :to="`/info/${contactWidget.contact_page.post_name}/`"
                >
                    <icon :icon="'phone'"></icon>
                    Kontakt
                </router-link>
                <transition name="c-m-menu-desktop__dropdown--animation">
                    <div
                        class="c-m-menu-desktop__dropdown c-m-menu-desktop__dropdown--expand-center c-m-menu-desktop__contact-info"
                        v-show="showContactInfo"
                    >
                        <p class="c-m-menu-desktop__contact-info-heading h3">
                            {{ contactWidget.cta_text }}
                        </p>
                        <p class="c-m-menu-desktop__contact-info-body h3">
                            <icon :icon="'phone'" />
                            <a
                                v-if="isMounted && $isMobile"
                                :href="contactWidget.phone_link.url"
                                >{{ contactWidget.phone_link.title }}</a
                            >
                            <span v-else>{{
                                contactWidget.phone_link.title
                            }}</span>
                        </p>
                        <div
                            class="c-m-menu-desktop__contact-info-hours"
                            v-html="contactWidget.hours"
                        ></div>
                        <button-link
                            class="c-m-menu-desktop__contact-info-button"
                            :label="'Fler kontaktsätt'"
                            :link="
                                `/info/${contactWidget.contact_page.post_name}/`
                            "
                            :modifiers="'c-a-button--theme-primary'"
                        ></button-link>
                    </div>
                </transition>
            </li>
            <li
                class="c-m-menu-desktop__item"
                v-if="queuedCompanies.length > 0 && isMounted"
                @click="displayAtClick('showQueue')"
                @mouseenter="showQueue = true"
                @mouseleave="showQueue = false"
            >
                <div
                    class="c-m-menu-desktop__link c-m-menu-desktop__link--flipped"
                >
                    <icon :icon="'list'"></icon>
                    <span>Valda ({{ queuedCompanies.length }} st)</span>
                </div>
                <transition name="c-m-menu-desktop__dropdown--animation">
                    <div
                        v-show="showQueue"
                        class="c-m-menu-desktop__dropdown c-m-menu-desktop__dropdown--expand-left c-m-menu-desktop__queue"
                    >
                        <queue></queue>
                    </div>
                </transition>
            </li>
            <li
                v-if="isAuthenticated && user"
                class="c-m-menu-desktop__item"
                @click="displayAtClick('showUserMenu')"
                @mouseenter="showUserMenu = true"
                @mouseleave="showUserMenu = false"
            >
                <div
                    class="c-m-menu-desktop__link c-m-menu-desktop__link--flipped"
                >
                    <icon :icon="'person'"></icon>
                    {{ user.name || user.userName }}
                </div>
                <transition name="c-m-menu-desktop__dropdown--animation">
                    <ul
                        class="c-m-menu-desktop__list c-m-menu-desktop__list--level-1 c-m-menu-desktop__dropdown c-m-menu-desktop__dropdown--expand-left"
                        v-show="showUserMenu"
                    >
                        <li class="c-m-menu-desktop__item">
                            <router-link
                                class="c-m-menu-desktop__link"
                                :to="{ path: '/mina-sidor/' }"
                            >
                                <icon :icon="'account_circle'"></icon>
                                Mina sidor
                            </router-link>
                        </li>
                        <li class="c-m-menu-desktop__item">
                            <div class="c-m-menu-desktop__button">
                                <atom-button
                                    :icon="'power_off'"
                                    @buttonClicked="handleLogOut"
                                    :label="'Logga ut'"
                                    class="c-a-button--theme-alert c-a-button--small"
                                ></atom-button>
                            </div>
                        </li>
                    </ul>
                </transition>
            </li>
            <li v-else class="c-m-menu-desktop__item">
                <router-link
                    class="c-m-menu-desktop__link c-m-menu-desktop__link--flipped"
                    :to="{ path: '/logga-in/' }"
                >
                    <icon :icon="'person'"></icon>
                    Logga in
                </router-link>
            </li>
        </ul>
    </nav>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import {
    GET_USER,
    IS_AUTHENTICATED,
    LOG_OUT
} from "../../../store/store-models/authentication-model";
import { GET_CONTACT_WIDGET } from "../../../store/store-models/meta-model.js";
import { GET_COMPANIES } from "../../../store/store-models/queued-companies-model";

import Avatar from "../atoms/AtomAvatar.vue";
import AtomButton from "../atoms/AtomButton.vue";
import ButtonLink from "../atoms/AtomButtonLink.vue";
import Icon from "../atoms/AtomIcon.vue";
import MenuItemDesktop from "./MoleculeMenuItemDesktop.vue";
import Queue from "./MoleculeQueuedCompanies.vue";

import filters from "../../../filters/index.js";

export default {
    filters: filters,
    components: {
        MenuItemDesktop,
        Icon,
        Avatar,
        ButtonLink,
        AtomButton,
        Queue
    },
    props: {
        isCompany: {
            type: Boolean,
            default: false
        },
        items: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            showContactInfo: false,
            showQueue: false,
            showUserMenu: false,
            isMounted: false
        };
    },
    computed: {
        ...mapGetters({
            contactWidget: GET_CONTACT_WIDGET,
            queuedCompanies: GET_COMPANIES,
            isAuthenticated: IS_AUTHENTICATED,
            userData: GET_USER
        }),
        user: function() {
            if (this.userData && Object.keys(this.userData).length > 0) {
                return this.userData;
            }

            return false;
        }
    },
    methods: {
        ...mapActions({
            logOut: LOG_OUT
        }),
        async handleLogOut() {
            await this.logOut();
            this.$router.push({
                name: "Logga in"
            });
        },
        displayAtClick(item) {
            if (item === "showContactInfo") {
                this.showContactInfo = !this.showContactInfo;
            } else if (item === "showQueue") {
                this.showQueue = !this.showQueue;
            } else if (item === "showUserMenu") {
                this.showUserMenu = !this.showUserMenu;
            }
        }
    },
    mounted() {
        this.isMounted = true;
    }
};
</script>



// WEBPACK FOOTER //
// src/views/components/molecules/MoleculeMenuDesktop.vue